<template>
  <div>
    <button @click.prevent="collapsed = !collapsed" class="lib__btn-action" type="button">
      <span class="lib__badge lib__badge--primary">
        <i :class="collapsed ? 'fa-plus' : 'fa-minus'" class="fas"></i>
      </span>
      <span class="lib__btn-action__label">{{ title }}</span>
    </button>
    <small class="cw__collapse-info__content" v-if="!collapsed">
      <slot></slot>
    </small>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'collapse-info'
})
export default class CollapseInfo extends Vue {
  //#region [Property]
  @Prop({ type: String, required: true }) public readonly title!: string;
  //#endregion

  //#region [Data]
  public collapsed: boolean = true;
  //#endregion
}
</script>

<style>
.cw__collapse-info__content {
  margin-left: 48px;
  margin-top: -15px;
}
</style>
